export enum ProductAction {
  addToCatalog = 'ProductAddToCatalogAction',
  errors = 'Errors',
}
